import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

// Store
import { Claim } from '@amfam/claim/data-access';
import { ClaimUtilService } from '@amfam/claim/shared/utility';
import { QuickLink } from '@amfam/shared/ui/quick-links';
import { CopyService } from '@amfam/shared/utility/shared-services';

// Models
import { ClaimActivity, ClaimGeneralDataModel, ClaimProgress } from '../../models';
import { ClaimDetailConstant } from '../../models/claim-detail-constants';
import { ClaimStatusService } from '../../services/claim-status-service';

@Component({
  selector: 'ds-property-claim-status',
  templateUrl: './property-claim-status.component.html',
  styleUrls: ['../auto-claim-status/auto-claim-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PropertyClaimStatusComponent implements OnInit {
  @Input() claim: Claim;

  claimNumber: string;
  quickLinksList = new Array<QuickLink>();
  claimGeneralData: ClaimGeneralDataModel;
  hasGeneralData = false;
  claimActivityData: ClaimActivity[];
  claimProgressData: ClaimProgress;
  amfamPhone: string = this.copyService.get('shared', 'amfamPhoneNumericNumber');
  summary = this.copyService.getCopy('shared.summary');
  payments = this.copyService.getCopy('shared.payments');
  closed = this.copyService.getCopy('shared.closed');
  claimDetailConstant = ClaimDetailConstant;
  private paymentsData = [];

  constructor(
    private claimUtilService: ClaimUtilService,
    private claimStatusService: ClaimStatusService,
    private copyService: CopyService
  ) {}

  ngOnInit() {
    this.claimNumber = this.claim.claimNumber;

    this.claimActivityData = this.claimStatusService.buildActivityData(
      this.claim,
      this.paymentsData,
      ClaimDetailConstant.PROPERTY
    );
    this.claimGeneralData = this.claimStatusService.buildGeneralData(this.claim);
    this.claimProgressData = this.claimStatusService.buildProgressData(
      this.claim,
      ClaimDetailConstant.PROPERTY
    );
    this.hasGeneralData = this.claimUtilService.checkObjPropsHasValue(this.claim);
  }

  public buildPaymentsData(claim: Claim) {
    return {
      claimProgress: claim.claimProgress,
      monetaryTransactions: this.paymentsData
    };
  }
}
